// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__27ovN","title":"FrontImage_title__31bbT"};